import { UPDATE_DEFAULT_PAYMENT } from './types';

const updateDefaultPayment = selected => ({
  type: UPDATE_DEFAULT_PAYMENT,
  payload: selected,
});

export default updateDefaultPayment;



// WEBPACK FOOTER //
// ./src/actions/userInformation/updateDefaultPayment.js